import React, { useState } from "react";
import ProductVisitedList from "./ProductVisitedList";
import ProductListing from "./ProductListing";
import ProductWishlistList from "./ProductWishlistList";
import OrderHistoryList from "./OrderHistoryList";
import IndividualOfferList from "./IndividualOfferList";
import CommunicationInbox from "./CommunicationInbox";
import CreateOrderModal from "./CreateOrderModal";

const ProductActivitySection = ({ userData }) => {
    const [activeTab, setActiveTab] = useState("visited");
    const [refreshOrders, setRefreshOrders] = useState(false);

    const menuItems = [
        { key: "visited", label: "Product Visited", count: userData?.recently_viewed_product_count || 0},
        { key: "wishlist", label: "Wishlist", count: userData?.wishlist_count || 0 },
        { key: "orders", label: "Order History", count: userData?.order_count || 0 },
        { key: "offers", label: "Individual Offers", count: userData?.coupon_count || 0, },
        { key: "communication", label: "Communication Inbox", count: 0 }
    ];

    const handleOrderCreated = () => {
    setRefreshOrders((prev) => !prev); // toggle to trigger useEffect in OrderHistoryList
  };

    
    const renderContent = () => {
        switch (activeTab) {
            case "visited":
                return (
                    <ProductVisitedList
                        userUid={userData?.uid}
                    />
                );

            case "wishlist":
                return (
                    <ProductWishlistList
                        userUid={userData?.uid}
                    />
                );

            case "orders":
                return (
                    <OrderHistoryList
                        userUid={userData?.uid}
                    />
                );

            case "sent":
                return <h4 className="text-lg">Sent Items Records</h4>;

            case "offers":
                return (
                    <IndividualOfferList
                        userUid={userData?.uid}
                    />
                );
            case "communication":
                return (
                    <CommunicationInbox
                        userUid={userData?.uid}
                        userData={userData}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border mt-6">
            <div className="border-b p-4  flex justify-between items-center w-full">
                <h3 className="text-2xl font-semibold">
                    PRODUCT
                </h3>
                 <div>
                    <CreateOrderModal userData={userData} onOrderCreated={handleOrderCreated} />
                 </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12">
                {/* Left Sidebar */}
                <div className="lg:col-span-3 border-r bg-slate-50 p-4">
                    <div className="space-y-3">
                        {menuItems.map((item) => (
                            <button
                                key={item.key}
                                onClick={() => setActiveTab(item.key)}
                                className={`w-full flex justify-between items-center p-3 rounded-lg transition-all ${activeTab === item.key ? "bg-blue-100 border-l-4 border-blue-600" : "hover:bg-gray-100"}`}
                            >
                                <span>{item.label}</span>

                                {item.key != "communication" &&(
                                <span className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full">
                                    {item.count}
                                </span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Right Content */}
                <div className="lg:col-span-9 p-6">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default ProductActivitySection;